import { BusinessUser } from '@models/businesses';
import { getInitials as nameInitials } from './string';

export const getInitials = (user: BusinessUser): string => {
	if (!user) {
		return '';
	}

	if (user.initials) {
		return user.initials;
	}

	const names = [user.firstName, user.lastName].filter((x) => !!x);

	return nameInitials(names.join(' '));
};
